module.exports = __webpack_public_path__ + "static/top-left-fc067889ff6cb6c1e16fe52c2b100f9c.png";